<template>
  <v-app>
    <!-- <v-navigation-drawer :="drawer" temporary fixed>
      <v-list>
        <v-list-item>
          <v-list-item-icon>
            <v-icon></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer> -->

    <v-app-bar app color="primary" dark>
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
      <v-toolbar-title class="font-weight-medium">{{ title }}</v-toolbar-title>

      <v-spacer />
      <v-btn text small v-if="!isAuthorized" :href="oauthLink">Login</v-btn>
      <!-- <v-btn text small v-if="!isAuthorized">Register</v-btn> -->
      <v-btn text small v-if="isAuthorized" @click.stop="logout">Logout</v-btn>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>

    <v-footer height="auto" color="primary" fixed app>
      <v-row align="center" justify="center">
        <span class="subtitle-2" style="color: white;">© {{ currentYear }} - dad2cl3.com</span>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
    title: "My Listing Bot",
    drawer: false,
    items: []
  }),
  computed: {
    isAuthorized: {
      get() {
        return this.$store.state.isAuthorized
      }
    },
    currentYear: {
      get() {
        return new Date().getFullYear()
      }
    },
    oauthLink() {
      let sessionState = localStorage.getItem("sessionGuid")

      if (!sessionState) {
        // sessionGUID not found in local storage
        this.$store.dispatch("generateSessionGuid")
        sessionState = this.$store.state.sessionGuid
      } else {
        // sessionGUID found in local storage
        this.$store.commit("setSessionGuid", sessionState)
      }

      let redirectUrl = encodeURIComponent(process.env.VUE_APP_REDIRECT_URL)
      // let url = "https://discordapp.com/api/oauth2/authorize?client_id=631467454228463656&redirect_uri=https%3A%2F%2Fwww.mylistingbot.com%2Fredirect&response_type=code&scope=identify&state=" + sessionState
      let url = `https://discordapp.com/api/oauth2/authorize?client_id=${process.env.VUE_APP_CLIENT_ID}&redirect_uri=${redirectUrl}&response_type=token&scope=identify&state=${sessionState}`
      return url
    }
  },
  methods: {
    logout() {
      // code to logout
      this.$emit("searchSelected", -1)
      // console.log('Logging out user...') // debug
      this.$store.dispatch("logout")
      // this.$router.replace('/')
    }
  },
  mounted() {},
  created() {
    // Does the cookie exist?
    let sessionToken = localStorage.getItem("sessionToken")
    let sessionTokenExpiration = new Date(localStorage.getItem("sessionTokenExpiration"))
    // console.log(`Expiration: ${sessionTokenExpiration}`)
    if (sessionToken) {
      // console.log("Token found...")
      let now = new Date()
      // console.log(`Now: ${now}`)
      // console.log(now<=sessionTokenExpiration)
      if (now < sessionTokenExpiration) {
        // add local storage to store
        // console.log("Adding local storage to store...")
        let sessionUser = localStorage.getItem("sessionUser")
        let sessionGuid = localStorage.getItem("sessionGuid")
        this.$store.commit("setSessionToken", sessionToken)
        this.$store.commit("setSessionTokenExpiration", sessionTokenExpiration)
        this.$store.commit("setUserId", sessionUser)
        this.$store.commit("setSessionGuid", sessionGuid)
        this.$store.commit("setAuthorized", true)
      } else {
        // clear local storage
        this.$store.dispatch("logout")
      }
    } else {
      return
    }
    // Yes grab Discord token
    // No require login
  }
};
</script>
